"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.selectTheme = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Select = ({
  name,
  value,
  placeholder,
  required,
  setValue,
  options,
  classes
}) => _react.default.createElement("select", {
  className: (0, _classnames.default)(classes.select, 'form-input form-select'),
  name: name,
  value: value,
  onChange: e => setValue(name, e.target.value, required)
}, (!value || !required) && _react.default.createElement("option", {
  value: "",
  disabled: required
}, placeholder || (required ? 'Select' : 'All')), options.map((item, index) => _react.default.createElement("option", {
  key: index,
  value: typeof item === 'string' ? item : item.value
}, typeof item === 'string' ? item : item.label)));

Select.propTypes = {
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  placeholder: _propTypes.default.node,
  required: _propTypes.default.bool,
  setValue: _propTypes.default.func.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    label: _propTypes.default.node,
    value: _propTypes.default.string
  })]))
};

const selectTheme = theme => ({
  select: {
    paddingRight: "35px !important",
    cursor: 'pointer',
    // Remove default caret
    '-webkit-appearance': 'none',
    '&::-ms-expand': {
      display: 'none'
    },
    // Custom caret
    '&:not([multiple])': {
      backgroundImage: "linear-gradient(45deg,transparent 50%,".concat(theme.colors.inputText, " 0),linear-gradient(135deg,").concat(theme.colors.inputText, " 50%,transparent 0)"),
      backgroundSize: '5px 5px, 5px 5px',
      backgroundRepeat: 'no-repeat'
    },
    '&[multiple]': {
      height: 'auto'
    },
    '&:-webkit-autofill': {
      backgroundColor: "".concat(theme.colors.inputBg, " !important"),
      transition: 'background-color 5000s ease-in-out 0s'
    }
  }
});

exports.selectTheme = selectTheme;

var _default = (0, _.withFormControl)((0, _reactJss.default)(selectTheme)(Select));

exports.default = _default;